/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./BasePropertyAction'
], function(BaseClass) {

	var BaseStylePropertyAction = null;
	BaseStylePropertyAction = BaseClass.extend({
		_getWidgetSize: function(style, propertyNodes) {
			let container = propertyNodes[0]._layout.widget ? propertyNodes[0]._layout.widget : propertyNodes[0]._layout;
			let widgetSize = this._getSize(style, container.$el);
			return widgetSize;
		},
		_getWidgetOffset: function(style, propertyNodes) {
			// We need to look at the parent offset and remove it from the widget offset val
			let container = propertyNodes[0]._layout.widget ? propertyNodes[0]._layout.widget : propertyNodes[0]._layout;
			let widgetOffset = this._getOffset(style, container.$el);
			let parentOffset = this._getOffset(style, propertyNodes[0]._layout.parentLayout.$el);
			return widgetOffset - parentOffset;
		},
		_getParentDim: function(style, propertyNodes) {
			const parentSize = this._getSize(style, propertyNodes[0]._layout.parentLayout.$el);
			return parentSize;
		},
		_getSize: function(style, $el) {
			return style === 'width' ? $el.width() : $el.height();
		},
		_getOffset: function(style, $el) {
			let offset = $el.offset();
			return style === 'width' ? offset.left : offset.top;
		},
		_sanitizePercentSizeOnPage: function(value, complimentaryProperty) {
			let sanitizedValue = value;
			sanitizedValue = Math.max(Math.min(100, sanitizedValue), 0); //% sizes need to be between 0 and 100

			let maxValue = 0;
			this.propertyNodes.forEach((node) => {
				maxValue = Math.max(maxValue, parseFloat(node._layout.model.style[complimentaryProperty]));
			});
			if (maxValue + sanitizedValue > 100) {
				sanitizedValue = 100 - maxValue;
			}

			return sanitizedValue;
		},

		_updateInputProperty: function(property, value) {
			this.ignoreOnChange = true; //setValue will trigger onChange again.
			property.setValue(value);
			property.onChangeValueHold = value;
			this.ignoreOnChange = false;
		},

		getUnitsFromValue: (value) => value.replace(/[\d.-]/g, ''),

		getValueString: (numericValue, units) => String(Number(numericValue.toFixed((units === 'px') ? 0 : 2))) + ' ' + units,

		changeProperty: function(action, id /*, value*/) {
			if (action.ignoreOnChange) {
				action.ignoreOnChange = false;
				return;
			}

			let numericValue = parseFloat(this.getValue());
			if (!isNaN(numericValue)) {
				numericValue = action._processChange.apply(action, [id, numericValue, this.units]);

				const stringValue = action.getValueString(numericValue, this.units);
				action._updateInputProperty(this, stringValue);
			} else {
				action._updateInputProperty(this, this.onChangeValueHold);
			}
		},

		wrapChangeProperty: function() {
			const action = this;
			return function() {
				let args = [action, ...arguments];
				action.changeProperty.apply(this, args);
			};
		},

		/**
		 * Get an arbitrary number of properties from the selected nodes for use in the properties pane. Values are only present if all nodes have the same value and
		 * the returned values are formatted properly for use in the properties pane.
		 *
		 * @param {Object[]} properties - Define the properties to fetch from the selected nodes.
		 * @param {Function} properties[].getProp - Function to retrieve the property from a node. Takes the node as a parameter and returns the property value.
		 * @param {String} properties[].units - Unit string to be appended to the final property.
		 * @param {Boolean} properties[].break - Added during this function. Set to true once this property no longer needs to be checked.
		 * @param {*} properties[].value - The final value used to return this property. Blank if not all properties matched.
		 */
		_getValuesForProperties: function(properties) {
			properties.forEach((property) => {
				property.value = property.getProp(this.propertyNodes[0]);
			});

			if (this.propertyNodes.length > 1) {
				for (let i=1; i<this.propertyNodes.length; i++) {
					let canBreak = true;

					properties.forEach((property) => {
						if (!property.break) {
							const currentValue = property.getProp(this.propertyNodes[i]);
							if (currentValue !== property.value)  {
								property.value = '';
								property.break = true;
							}
						}
					});

					if(canBreak) {
						break;
					}
				}
			}

			properties.forEach((property) => {
				if (property.value !== '') {
					property.value = this.getValueString(parseFloat(property.value), property.units);
				}
			});
		},

		showStyleProperties: function(node) {
			const parentLayout = node._layout.parentLayout;
			if (parentLayout && parentLayout.model && parentLayout.model.type === 'group') {
				return false;
			}
			return true;
		},

		getProperties: function() {
			this.propertyNodes = this.selectedNodes;
		}
	});

	return BaseStylePropertyAction;

});
